// Generated by ReScript, PLEASE EDIT WITH CARE

import * as InstaMojo from "../types/basic-order/InstaMojo.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(instaMojoJson) {
  return DeccoUtils$Catalyst.resolveResult(InstaMojo.t_decode(instaMojoJson), "InstaMojoDetailsStateMapper.re");
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
